import { createContext, useContext, useState } from 'react';

// ── Translation table ──────────────────────────────────────────
const TRANSLATIONS = {
  // Nav
  'nav.trending':   { zh: '二级热榜',  en: 'Secondary Hot List' },
  'nav.pipeline':   { zh: '早期雷达', en: 'Early Radar' },
  'nav.analyze':    { zh: '项目分析',  en: 'Analyze' },
  'nav.ranking':    { zh: 'Deal Ranking', en: 'Rankings' },
  'nav.watchlist':  { zh: '收藏夹',    en: 'Watchlist' },
  'nav.talentRadar': { zh: '人才雷达', en: 'Talent Radar' },
  'nav.compare':    { zh: '对比分析',  en: 'Compare' },
  'nav.settings':   { zh: '评分设置',  en: 'Settings' },
  'nav.overview_label': { zh: '概览',  en: 'Overview' },
  'nav.analyzed':   { zh: '已分析',    en: 'Analyzed' },
  'nav.sa_grade':   { zh: 'S/A 评级', en: 'S/A Grade' },
  'nav.high_alpha': { zh: '高 Alpha', en: 'High Alpha' },
  'nav.login':      { zh: '登录 / 注册', en: 'Sign In / Up' },
  'nav.logout':     { zh: '退出登录',  en: 'Sign Out' },

  // Detail panel tabs
  'tab.overview':  { zh: '概览',  en: 'Overview' },
  'tab.scores':    { zh: '评分',  en: 'Scores' },
  'tab.irr':       { zh: 'IRR',   en: 'IRR' },
  'tab.comp':      { zh: '竞品',  en: 'Comps' },
  'tab.unlock':    { zh: '解锁',  en: 'Unlock' },
  'tab.data':      { zh: '数据',  en: 'Data' },
  'tab.intel':     { zh: '情报',  en: 'Intel' },
  'tab.history':   { zh: '历史',  en: 'History' },
  'tab.research':  { zh: '研报',  en: 'Research' },
  'tab.notes':     { zh: '笔记',  en: 'Notes' },
  'tab.bp_verify': { zh: 'BP 核查', en: 'BP Check' },

  // Detail panel buttons
  'btn.reanalyze': { zh: '重新分析',  en: 'Re-analyze' },
  'btn.watchlist': { zh: '收藏',      en: 'Watchlist' },
  'btn.share':     { zh: '分享卡片',  en: 'Share Card' },
  'btn.badge':     { zh: '项目徽章',  en: 'Badge' },
  'btn.report':    { zh: '研究报告',  en: 'Report' },

  // Dimension labels
  'dim.tech':        { zh: '技术',      en: 'Tech' },
  'dim.team':        { zh: '团队',      en: 'Team' },
  'dim.narrative':   { zh: '叙事',      en: 'Narrative' },
  'dim.data':        { zh: '数据',      en: 'Data' },
  'dim.token':       { zh: '代币',      en: 'Token' },
  'dim.compliance':  { zh: '合规',      en: 'Compliance' },

  // Score section headings
  'score.composite':  { zh: '综合评分',           en: 'Composite Score' },
  'score.narrative':  { zh: '叙事与愿景',          en: 'Narrative & Vision' },
  'score.tech':       { zh: '技术与产品',          en: 'Tech & Product' },
  'score.team':       { zh: '团队背景',            en: 'Team' },
  'score.token':      { zh: '代币经济',            en: 'Tokenomics' },
  'score.data':       { zh: '数据表现',            en: 'On-chain Data' },
  'score.compliance': { zh: '合规风险',            en: 'Compliance' },
  'score.framework':  { zh: '评分框架',            en: 'Score Framework' },
  'score.basis':      { zh: '判断依据',            en: 'Basis' },
  'score.data_basis': { zh: '数据依据',            en: 'Data Source' },

  // Overview section labels
  'overview.thesis':      { zh: '投资建议',   en: 'Investment Thesis' },
  'overview.moat':        { zh: '核心护城河', en: 'Core Moat' },
  'overview.strengths':   { zh: '核心优势',   en: 'Key Strengths' },
  'overview.risks':       { zh: '主要风险',   en: 'Key Risks' },
  'overview.catalysts':   { zh: '催化剂',     en: 'Catalysts' },
  'overview.comps':       { zh: '竞品估值对标', en: 'Comparable Valuations' },
  'overview.stage_label': { zh: '评分框架',   en: 'Score Framework' },

  // Comp table headers
  'comp.project':    { zh: '项目',    en: 'Project' },
  'comp.fdv':        { zh: 'FDV',     en: 'FDV' },
  'comp.stage':      { zh: '阶段',    en: 'Stage' },
  'comp.similarity': { zh: '相似点',  en: 'Similarity' },
  'comp.pricing':    { zh: '相对定价', en: 'Relative Pricing' },

  // Stage labels
  'stage.early':      { zh: '早期阶段',   en: 'Early Stage' },
  'stage.product':    { zh: '产品阶段',   en: 'Product Stage' },
  'stage.growth':     { zh: '成长期',     en: 'Growth Stage' },
  'stage.tge_post':   { zh: 'TGE后',      en: 'Post-TGE' },

  // Unlock pressure
  'unlock.low':    { zh: '解锁压力低',  en: 'Low unlock pressure' },
  'unlock.medium': { zh: '解锁压力中',  en: 'Medium unlock pressure' },
  'unlock.high':   { zh: '解锁压力高',  en: 'High unlock pressure' },

  // Portfolio filters
  'filter.all':        { zh: '全部',   en: 'All' },
  'filter.watching':   { zh: '观察中', en: 'Watching' },
  'filter.research':   { zh: '研究中', en: 'Research' },
  'filter.diligence':  { zh: '尽调中', en: 'Due Diligence' },
  'filter.pass':       { zh: '通过',   en: 'Pass' },
  'filter.invested':   { zh: '已投',   en: 'Invested' },
  'filter.pass_label': { zh: 'Pass',   en: 'Pass' },
  'filter.pre_token':  { zh: '未发币', en: 'Pre-token' },
  'filter.live':       { zh: '已上线', en: 'Live' },
  'filter.min_score':  { zh: '最低评分', en: 'Min Score' },

  // Portfolio table headers
  'table.project': { zh: '项目',   en: 'Project' },
  'table.track':   { zh: '赛道',   en: 'Track' },
  'table.score':   { zh: '综合评分', en: 'Score' },
  'table.fdv':     { zh: '低估倍数', en: 'FDV Multiple' },
  'table.irr':     { zh: '期望IRR', en: 'Est. IRR' },
  'table.alpha':   { zh: 'ALPHA',  en: 'ALPHA' },
  'table.unlock':  { zh: '解锁',   en: 'Unlock' },
  'table.stage':   { zh: '阶段',   en: 'Stage' },
  'table.saved':   { zh: '收藏',   en: 'Saved' },
  'table.action':  { zh: '操作',   en: 'Action' },
  'table.remove':  { zh: '移除',   en: 'Remove' },

  // Status
  'status.watching':    { zh: '观察中', en: 'Watching' },
  'status.researching': { zh: '研究中', en: 'Researching' },
  'status.diligence':   { zh: '尽调中', en: 'Due Diligence' },
  'status.pass':        { zh: '通过',   en: 'Pass' },
  'status.invested':    { zh: '已投',   en: 'Invested' },

  // IRR panel
  'irr.alpha_formula':  { zh: '低估倍数 × E[IRR] × 质量因子',   en: 'FDV Multiple × E[IRR] × Quality Factor' },
  'irr.expected_mult':  { zh: '期望回报倍数',  en: 'Expected Return' },
  'irr.expected_irr':   { zh: '期望 IRR / 年', en: 'Est. IRR / Year' },
  'irr.entry_val':      { zh: '入场估值',      en: 'Entry Valuation' },
  'irr.fair_val':       { zh: '公允价值',      en: 'Fair Value' },
  'irr.under_mult':     { zh: '低估倍数',      en: 'FDV Multiple' },
  'irr.undervalued':    { zh: '低估',          en: 'Undervalued' },
  'irr.overvalued':     { zh: '高估',          en: 'Overvalued' },
  'irr.return_dist':    { zh: '回报分布',       en: 'Return Distribution' },
  'irr.fdv_tiers':      { zh: 'FDV 分层建议',  en: 'FDV Tier Guide' },
  'irr.tier_range':     { zh: '估值区间',       en: 'Valuation Range' },
  'irr.tier_rating':    { zh: '评级',           en: 'Rating' },
  'irr.tier_position':  { zh: '建议仓位',       en: 'Position Size' },
  'irr.tier_return':    { zh: '预期回报',       en: 'Expected Return' },
  'irr.exit_paths':     { zh: '退出路径',       en: 'Exit Paths' },
  'irr.ai_estimate':    { zh: 'AI 估算',        en: 'AI Estimate' },
  'irr.current_entry':  { zh: '当前入场价',     en: 'Current entry' },
  'irr.no_data':        { zh: '无估值数据，无法计算 IRR', en: 'No valuation data — cannot calculate IRR' },
  'irr.implied_val':    { zh: '推算估值(25%稀释)', en: 'Implied Val. (25% dilution)' },
  'irr.current_fdv':    { zh: '当前FDV',        en: 'Current FDV' },
  'irr.latest_round':   { zh: '最近轮估值',     en: 'Latest round val.' },

  // Unlock tab
  'unlock.overall':     { zh: '整体解锁压力',   en: 'Overall Unlock Pressure' },
  'unlock.tge_status':  { zh: 'TGE 状态',       en: 'TGE Status' },
  'unlock.timeline':    { zh: '解锁时间轴',      en: 'Unlock Timeline' },
  'unlock.position_guide': { zh: '建仓减仓节奏建议', en: 'Position Timing Guide' },
  'unlock.no_timeline': { zh: '暂无解锁时间轴数据，重新分析可获取', en: 'No unlock timeline — re-analyze to fetch data' },
  'unlock.no_high':     { zh: '✅ 无明显高抛压节点', en: '✅ No significant high-pressure events' },
  'unlock.exit_tip':    { zh: '💡 建议在 TGE 后首次高抛压前完成主要获利了结', en: '💡 Take primary profits before the first high-pressure event post-TGE' },
  'unlock.pressure_high':   { zh: '高压力', en: 'High' },
  'unlock.pressure_medium': { zh: '中压力', en: 'Medium' },
  'unlock.pressure_low':    { zh: '低压力', en: 'Low' },

  // Evidence labels in Scores tab
  'ev.positioning':     { zh: '项目定位',   en: 'Positioning' },
  'ev.track':           { zh: '赛道',        en: 'Track' },
  'ev.ai_track':        { zh: 'AI赛道分类',  en: 'AI Category' },
  'ev.on_chain':        { zh: '链上数据',    en: 'On-chain Data' },
  'ev.lead_investors':  { zh: '领投机构',    en: 'Lead Investors' },
  'ev.investor_count':  { zh: '投资方数量',  en: 'Investor Count' },
  'ev.founded':         { zh: '成立时间',    en: 'Founded' },
  'ev.token_status':    { zh: '代币状态',    en: 'Token Status' },
  'ev.valuation_basis': { zh: '估值依据',    en: 'Valuation Basis' },
  'ev.data_status':     { zh: '数据状态',    en: 'Data Status' },
  'ev.no_data':         { zh: '暂无链上/市场数据', en: 'No on-chain / market data' },
  'ev.tge_status':      { zh: 'TGE 状态',   en: 'TGE Status' },
  'ev.unlock_pressure': { zh: '解锁压力',    en: 'Unlock Pressure' },
  'ev.compliance_track':{ zh: '合规敏感赛道', en: 'Compliance-Sensitive Track' },
  'ev.token_issued':    { zh: '已发行',      en: 'Issued' },
  'ev.token_not_issued':{ zh: '未发行',      en: 'Not issued' },
  'ev.not_launched':    { zh: '未上线/无链上记录', en: 'Not launched / no on-chain records' },
  'ev.firms_count':     { zh: '家',          en: ' firms' },
  'ev.pressure_low':    { zh: '低',          en: 'Low' },
  'ev.pressure_mid':    { zh: '中',          en: 'Mid' },
  'ev.pressure_high':   { zh: '高',          en: 'High' },
  'ev.yes':             { zh: '是',          en: 'Yes' },

  // Data tab
  'data.founded':       { zh: '成立时间', en: 'Founded' },
  'data.token':         { zh: '代币',     en: 'Token' },
  'data.total_funding': { zh: '总融资额', en: 'Total Funding' },
  'data.not_issued':    { zh: '未发行',   en: 'Not issued' },
  'data.onchain':       { zh: '链上数据 · DeFiLlama', en: 'On-chain Data · DeFiLlama' },
  'data.onchain2':      { zh: '链上数据（DeFiLlama）', en: 'On-chain Data (DeFiLlama)' },
  'data.daily_volume':  { zh: '日交易量', en: 'Daily Volume' },
  'data.daily_fees':    { zh: '日协议费用', en: 'Daily Fees' },
  'data.24h_volume':    { zh: '24h 交易量', en: '24h Volume' },
  'data.24h_fees':      { zh: '24h 费用', en: '24h Fees' },
  'data.24h_trades':    { zh: '24h 成交量', en: '24h Volume' },
  'data.no_defillama':  { zh: 'DeFiLlama 未收录该协议（未上线或仅限测试网）', en: 'Protocol not listed on DeFiLlama (not launched or testnet only)' },
  'data.daily_users':   { zh: '日活用户', en: 'Daily Users' },
  'data.github_stars':  { zh: 'GitHub Stars', en: 'GitHub Stars' },
  'data.github_commits':{ zh: '近期 commits', en: 'Recent Commits' },
  'data.7d':            { zh: '7日', en: '7d' },

  // Comp tab
  'comp.header':        { zh: '竞品估值对标',  en: 'Comparable Valuations' },
  'comp.pricing_note':  { zh: '相对定价：当前项目公允价值 vs 竞品已交易估值对比', en: 'Relative pricing: project fair value vs comparable traded valuations' },

  // Misc
  'misc.not_recommended': { zh: '不建议投资', en: 'Not Recommended' },
  'misc.watch':           { zh: '观察',       en: 'Watch' },
  'misc.consider':        { zh: '考虑',       en: 'Consider' },
  'misc.invest':          { zh: '建议投资',   en: 'Invest' },
  'misc.ai_content_note': { zh: '',           en: '(AI analysis in Chinese)' },
  'misc.updates_link':    { zh: '产品更新',   en: 'Updates' },
  'misc.privacy_link':    { zh: '隐私政策',   en: 'Privacy' },
  'misc.terms_link':      { zh: '服务条款',   en: 'Terms' },
  'misc.contact_link':    { zh: '联系我们',   en: 'Contact' },
};

// ── Context ────────────────────────────────────────────────────
const LangContext = createContext({ lang: 'zh', setLang: () => {} });

export function LangProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem('pl_lang') || 'zh');
  const changeLang = (l) => {
    setLang(l);
    try { localStorage.setItem('pl_lang', l); } catch {}
  };
  return (
    <LangContext.Provider value={{ lang, setLang: changeLang }}>
      {children}
    </LangContext.Provider>
  );
}

export function useLang() {
  return useContext(LangContext);
}

/** Translate a key. Falls back to zh if en missing, then returns key itself. */
export function useT() {
  const { lang } = useLang();
  return (key) => {
    const entry = TRANSLATIONS[key];
    if (!entry) return key;
    return entry[lang] ?? entry.zh ?? key;
  };
}

/** Standalone translate — pass lang explicitly (for non-hook contexts). */
export function tr(key, lang = 'zh') {
  const entry = TRANSLATIONS[key];
  if (!entry) return key;
  return entry[lang] ?? entry.zh ?? key;
}
